import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { businessManagementData } from '../../data/departmentalData/businessManagement';
import './BusinessManagement.css';

const BusinessManagement = () => {
  return <TemplatePage data={businessManagementData} />;
};

export default BusinessManagement;